import React, { Component } from "react";
import Swal from "sweetalert2";
import { subUserCreate } from "../../action/auth";
import { onChange, validateForm } from "../../utils";
import ManageUserRightMenu from "../ManageSubusers/ManageUserRightMenu";
export default class UserCreate extends Component {
  constructor(props) {
    super(props);
    const details = props.details;
    console.log(details);
    debugger
    this.state = {
      name: {
        name: "name",
        value: details ? details.SUB_USER_FULL_NAME : "",
        options: [],
        error: "",
        isRequired: true,
      },
      email: {
        name: "email",
        value: details ? details.SUB_USER_EMAIL_ID : "",
        options: [],
        error: "",
        isRequired: true,
      },
      status: {
        name: "status",
        value: details ? details.STATUS : "",
        options: [],
        error: "",
        isRequired: true,
      },
      phone: {
        name: "phone",
        value: details ? details.SUB_USER_PHONE : "",
        options: [],
        error: "",
        isRequired: true,
      },
      username: {
        name: "username",
        value: details ? details.SUB_USER_USERNAME : "",
        options: [],
        error: "",
        isRequired: true,
      },
      password: {
        name: "password",
        value: "",
        options: [],
        error: "",
        isRequired: this.props?.id ? false : true,
      },
    };
  }

  onChange = (e) => {
    const { name, value } = e.target;
    onChange(this, name, value);
  };

  onSubmit = (e) => {
    e.preventDefault();
    if (validateForm(this)) {
      const { name, email, status, phone, username, password } = this.state;
      if (this.props?.id) {
        let data = {
          name: name.value,
          email: email.value,
          status: status.value,
          phone: phone.value,
          username: username.value,
          password: password.value,
          SUB_USER_ID: this.props.id,
        };
        this.props.onSubmit(data);
      } else {
        let data = {
          name: name.value,
          email: email.value,
          status: status.value,
          phone: phone.value,
          username: username.value,
          password: password.value,
        };
        this.props.onSubmit(data);
      }
    }
  };

  render() {
    const { name, email, status, phone, username, password } = this.state;
    return (
      <React.Fragment>
        <section className="pricing-area padding-top-100px padding-bottom-80px">
          <div className="container">
            <div className="row">
              <div className="col-md-3 mt-3">
                <ManageUserRightMenu />
              </div>
              <div className="col-md-9">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="breadcrumb-content d-flex flex-wrap justify-content-between align-items-center">
                      <ul className="list-items d-flex align-items-center">
                        <li className="active__list-item text-secondary">
                          Home
                        </li>
                        <li className="active__list-item text-secondary">
                          Dashboard
                        </li>
                        <li className="active__list-item text-secondary">
                          Manage Subusers
                        </li>
                        <li className="text-secondary">{this.props?.id ? 'Update User' : 'Create User'}</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-lg-12">
                    <div className="billing-form-item mb-0">
                      <div className="billing-title-wrap">
                        <h3 className="widget-title pb-0">
                          {this.props?.id ? "Update User" : "Create User"}
                        </h3>
                        <div className="title-shape margin-top-5px"></div>
                      </div>
                      <div className="billing-content">
                        <div className="postjob-form-action">
                          <form onSubmit={this.onSubmit}>
                            <div className="row">
                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Full Name
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        name.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      placeholder='Enter the Full Name'
                                      type="text"
                                      name={name.name}
                                      value={name.value}
                                      onChange={this.onChange}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Employer Email ID
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        email.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      placeholder='Enter the Email'
                                      type="text"
                                      name={email.name}
                                      value={email.value}
                                      onChange={this.onChange}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Status
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group ">
                                    <select
                                      className={
                                        status.error.length > 0
                                          ? "form-control is-invalid postjob-select-container"
                                          : "form-control"
                                      }
                                      name={status.name}
                                      value={status.value}
                                      onChange={this.onChange}
                                    >
                                      <option value="" >Select Status</option>
                                      <option value="A">Active</option>
                                      <option value="I">Disabled</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Phone
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      type="text"
                                      className={
                                        phone.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      placeholder='Enter the Phone'
                                      name={phone.name}
                                      value={phone.value}
                                      onChange={this.onChange}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Username
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      type="text"
                                      className={
                                        username.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      placeholder='Enter the Username'
                                      name={username.name}
                                      value={username.value}
                                      onChange={this.onChange}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Password
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      type="text"
                                      className={
                                        password.error.length > 0
                                          ? "form-control is-invalid postjob-select"
                                          : "form-control"
                                      }
                                      placeholder='Enter the Password'
                                      name={password.name}
                                      value={password.value}
                                      onChange={this.onChange}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-lg-12 pl-4">
                                  <div class="btn-box mt-4 pl-1">
                                    <button
                                      type="submit"
                                      class="theme-btn border-0"
                                    >
                                      <i className={`la la-${this.props?.id ? 'edit' : 'plus'}`}></i> {this.props?.id ? 'Update' : 'Create'} Sub User
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
